import React from 'react';
import { motion } from 'framer-motion';
const mediaLogos = [{
  name: 'The New York Times',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/5/58/NewYorkTimes.svg',
  width: 'w-32'
}, {
  name: 'BBC News',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/1/11/BBC_News_2022_%28Alt%29.svg',
  width: 'w-20'
}, {
  name: 'CNN',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/CNN.svg',
  width: 'w-20'
}, {
  name: 'National Geographic',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/1/13/National_Geographic_Logo.svg',
  width: 'w-32'
}, {
  name: 'The Guardian',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/The_Guardian.svg',
  width: 'w-32'
}, {
  name: 'Forbes',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/3/32/Forbes_logo.svg',
  width: 'w-24'
}];
export function FeaturedIn() {
  return <section className="py-20 bg-white border-t border-gray-100" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-97">
          <span className="text-[#5D6D7E] font-medium tracking-widest uppercase text-sm" data-id="element-98">
            As Featured In
          </span>
        </motion.div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-12 items-center justify-items-center" data-id="element-99">
          {mediaLogos.map((media, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative" data-id="element-100">
              <div className={`${media.width} h-12 flex items-center justify-center grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500`} data-id="element-101">
                <img src={media.logo} alt={media.name} className="w-full h-full object-contain" onError={e => {
              // Fallback to text if logo fails to load
              e.currentTarget.style.display = 'none';
              const parent = e.currentTarget.parentElement;
              if (parent) {
                parent.innerHTML = `<span class="font-serif text-lg font-bold text-gray-400 group-hover:text-gray-700 transition-colors">${media.name}</span>`;
              }
            }} data-id="element-102" />
              </div>
            </motion.div>)}
        </div>

        {/* Optional: Press Quote */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-103">
          <blockquote className="font-serif text-xl md:text-2xl text-[#5D6D7E] italic leading-relaxed" data-id="element-104">
            "Supradhyan Enlightenment Center stands as a beacon of authentic
            spiritual practice in the modern world, bridging ancient wisdom with
            contemporary needs."
          </blockquote>
          <cite className="not-italic text-sm text-[#8B9D83] font-medium mt-4 block" data-id="element-105">
            — Mindful Living Magazine
          </cite>
        </motion.div>
      </div>
    </section>;
}